import React from 'react'
import {useIntl} from 'react-intl'
import {useFormikContext} from 'formik'
import {SupplierOperation} from '../../core/_models'

const Subtotal = () => {
  const intl = useIntl()
  const {values} = useFormikContext()
  const order = values as SupplierOperation
  const evat = (order?.products || []).reduce((total, _) => {
    return total + (parseFloat((_.amount / ((100 + _.vat) / 100) * (100 - _.discount) / 100).toFixed(2)) * _.qty)
  }, 0 ).toFixed(2)
  const ivat = (order?.products || []).reduce((total, _) => {
    return total + (parseFloat((_.amount * (100 - _.discount) / 100).toFixed(2)) * _.qty)
  }, 0 ).toFixed(2)
  return (
    <div className="d-flex justify-content-end">
      <div className="mw-300px">
        <div className="d-flex flex-stack mb-3">
          <div className="fw-semibold pe-10 text-gray-600 fs-7">Subotal EXT:</div>
          <div className="text-end fw-bold fs-6 text-gray-800">
            {intl.formatNumber(parseFloat(evat), {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        </div>
        <div className="d-flex flex-stack mb-3">
          <div className="fw-semibold pe-10 text-gray-600 fs-7">VAT 20%</div>
          <div className="text-end fw-bold fs-6 text-gray-800">
            {intl.formatNumber(parseFloat(ivat) - parseFloat(evat), {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        </div>
        <div className="d-flex flex-stack">
          <div className="fw-semibold pe-10 text-gray-600 fs-7">Total</div>
          <div className="text-end fw-bold fs-6 text-gray-800">
            {intl.formatNumber(parseFloat(ivat), {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Subtotal
